import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login/index.vue'),
    },
    //我的待办
    {
      path: '/',
      name: 'tasks',
      component: () => import('@/pages/tasks/index.vue'),
    },
    //测量类型任务待办展示
    {
      path: '/task/celiang',
      name: 'celiang',
      component: () => import('@/pages/tasks/celiang.vue'),
    },
    {
      path: '/task/todo',
      name: 'todo',
      component: () => import('@/pages/tasks/todo.vue'),
    },
    {
      path: '/task/todo_ct',
      name: 'todo_ct',
      component: () => import('@/pages/tasks/todo_ct.vue'),
    },
    {
      path: '/task/todo_sc',
      name: 'todo_sc',
      component: () => import('@/pages/tasks/todo_sc.vue'),
    },

    //我的流程
    {
      path: '/process',
      name: 'process',
      component: () => import('@/pages/process/process.vue'),
    },
    //我的
    {
      path: '/mine',
      name: 'mine',
      component: () => import('@/pages/mine/mine.vue'),
    },
    //知识库
     {
      path: '/knowledge',
      name: 'knowledge',
      component: () => import('@/pages/knowledge/knowledge.vue'),
    },
    //我的流程-井巷工程测量填写
    {
      path: '/processEngineering',
      name: 'processEngineering',
      component: () => import('@/pages/process/engineering.vue'),
    },
    //我的已办
    {
      path: '/done',
      name: 'done',
      component: () => import('@/pages/tasks/index.vue'),
    },
    //生产沟通函展示
    {
      path: '/product',
      name: 'product',
      component: () => import('@/pages/product/product.vue'),
    },
    //填充实施单1
    {
      path: '/task/ctssd',
      name: 'ctssd',
      component: () => import('@/pages/tasks/ctssd.vue'),
    },
    //在线审查
    {
      path: '/task/preview',
      name: 'preview',
      component: () => import('@/pages/tasks/preview.vue'),
    },
    //403
    {
      path: '/page/403',
      name: '403',
      component: () => import('@/pages/403.vue'),
    },
    //404
    {
      path: '/page/404',
      name: '404',
      component: () => import('@/pages/404.vue'),
    },
    //调试地址页面
    {
      path: '/index',
      name: 'index',
      component: () => import('@/pages/index.vue'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js